import React from 'react';

import cn from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { AdvancementsTabsNames } from '@modules/advancement/pendingItems/constants';
import { setActiveAdvancementsTab } from '@modules/advancement/pendingItems/duck/actions';
import { featureFlags } from '@modules/featureFlags/utils/featureFlags';

import { navigateToTab } from '../../../common/actions';
import { tabNames } from '../../../common/constants';
import {
  openErrorsModal,
  uploadFileCancel,
  uploadFileRequest,
} from '../../duck/actions';
import {
  uploadErrorDescSel,
  uploadErrorSel,
  uploadProgressSel,
  uploadedFilesSel,
  uploadingSel,
} from '../../duck/selectors';
import ErrorsModal from './ErrorsModal';
import UploadDropzone from './UploadDropzone';
import styles from './UploadForm.less';
import UploadStats from './UploadStats';
import UploadsList from './UploadsList';

class UploadForm extends React.PureComponent {
  state = {
    selectedFile: null,
  };

  handleUpload = selectedFile => {
    this.setState({ selectedFile });
    this.props.onUpload(selectedFile);
  };

  handleCancelUpload = () => {
    this.setState({ selectedFile: null });
    this.props.onCancelUpload();
  };

  handleNavigateToHistory = () => {
    this.props.onCancel();
    this.props.onNavigateToHistory();
  };

  render() {
    const {
      uploading,
      progress,
      uploadedFiles,
      uploadError,
      uploadErrorDesc,
      onShowErrors,
    } = this.props;
    const { selectedFile } = this.state;
    const showAside = uploading || uploadedFiles.length || uploadError;

    return (
      <div className={cn(styles.container, { [styles.showAside]: showAside })}>
        <ErrorsModal />
        <UploadDropzone
          className={styles.dropzone}
          disabled={uploading}
          onDrop={this.handleUpload}
        />
        <div className={styles.aside}>
          <UploadsList
            className={styles.uploads}
            uploading={uploading}
            progress={progress}
            uploadedFiles={uploadedFiles}
            uploadError={uploadError}
            selectedFile={selectedFile}
            uploadErrorDesc={uploadErrorDesc}
            onRetry={this.handleUpload}
            onCancel={this.handleCancelUpload}
            onShowErrors={onShowErrors}
          />
          <UploadStats
            className={styles.stats}
            uploadedCount={uploadedFiles.length}
            onNavigateToHistory={this.handleNavigateToHistory}
          />
        </div>
      </div>
    );
  }
}

UploadForm.propTypes = {
  // provided by parent
  onCancel: PropTypes.func.isRequired,
  // provided by component itself
  uploading: PropTypes.bool.isRequired,
  progress: PropTypes.object.isRequired,
  uploadedFiles: PropTypes.array.isRequired,
  uploadError: PropTypes.bool.isRequired,
  uploadErrorDesc: PropTypes.array.isRequired,
  onUpload: PropTypes.func.isRequired,
  onCancelUpload: PropTypes.func.isRequired,
  onNavigateToHistory: PropTypes.func.isRequired,
  onShowErrors: PropTypes.func.isRequired,
};

const mapState = state => ({
  uploading: uploadingSel(state),
  progress: uploadProgressSel(state),
  uploadedFiles: uploadedFilesSel(state),
  uploadError: uploadErrorSel(state),
  uploadErrorDesc: uploadErrorDescSel(state),
});

const mapDispatch = dispatch => ({
  onUpload: file => dispatch(uploadFileRequest(file)),
  onCancelUpload: () => dispatch(uploadFileCancel()),
  onNavigateToHistory: () => {
    const hideHistory = featureFlags.getFlag('SBL_4463_HIDE_HISTORY_TAB');
    if (hideHistory) {
      dispatch(setActiveAdvancementsTab(AdvancementsTabsNames.HISTORY));
      dispatch(navigateToTab(tabNames.ADVANCEMENTS));
    } else {
      dispatch(navigateToTab(tabNames.ACTIVITY));
    }
  },
  onShowErrors: () => dispatch(openErrorsModal()),
});

export default connect(mapState, mapDispatch)(UploadForm);
